import { css } from 'styled-components';
import token from 'styled-token';
import { StyledTab } from '../../components/Tab/Tab.styles';
import { TABS_APPEARANCES } from '../../constants';
import { hexToAlpha } from '../../util/hexToAlpha';
import { inlineMediaQueryMixin } from '../inlineMediaQueryMixin';
import { spaceMixin } from '../spaceMixin';
var defaultTabCSS = function defaultTabCSS(props) {
  return token({
    backgroundColor: 'Tabs.backgroundColor',
    borderWidth: 'Button.borderWidth',
    borderColor: 'Tabs.Tab.default.borderColor',
    borderRadius: 'Button.borderRadius',
    fontColorHover: 'Tabs.fontColorHover',
    indicatorBorderRadius: 'Button.borderRadius',
    selectedTabIndicatorColor: 'Tabs.selectedTabIndicatorColor',
    selectedTabIndicatorHeight: 'Tabs.selectedTabIndicatorHeight',
    defaultTabBorderRadius: 'Tabs.Tab.default.borderRadius',
    tabPadding: 'Tabs.Tab.default.padding',
    tabTransitionDuration: 'Tabs.Tab.default.transition.duration',
    tabTransitionEasing: 'Tabs.Tab.default.transition.easing',
    tabTransitionProperty: 'Tabs.Tab.default.transition.property'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      borderWidth = _ref.borderWidth,
      borderColor = _ref.borderColor,
      borderRadius = _ref.borderRadius,
      fontColorHover = _ref.fontColorHover,
      indicatorBorderRadius = _ref.indicatorBorderRadius,
      selectedTabIndicatorColor = _ref.selectedTabIndicatorColor,
      selectedTabIndicatorHeight = _ref.selectedTabIndicatorHeight,
      _ref$defaultTabBorder = _ref.defaultTabBorderRadius,
      defaultTabBorderRadius = _ref$defaultTabBorder === void 0 ? 0 : _ref$defaultTabBorder,
      tabPadding = _ref.tabPadding,
      tabTransitionDuration = _ref.tabTransitionDuration,
      tabTransitionEasing = _ref.tabTransitionEasing,
      tabTransitionProperty = _ref.tabTransitionProperty;
    return css(["border-bottom:", "px solid ", ";", "{position:relative;border:0;border-radius:", "px;padding:", ";transition:", " ", "s ", ";&:first-child{border-top-left-radius:", "px;border-bottom-left-radius:0;}&:last-child{border-top-right-radius:", "px;border-bottom-right-radius:0;}&:hover:not(:disabled),&:active:not(:disabled){background-color:", ";color:", ";}&[aria-selected='true']{background-color:", ";padding:", ";}&[aria-selected='true']:before{background-color:", ";border-radius:", "px ", "px 0 0;bottom:0;content:'';display:block;height:", "px;left:0;position:absolute;width:100%;}}"], borderWidth, borderColor, StyledTab, defaultTabBorderRadius, tabPadding ? tabPadding + "px" : spaceMixin('sm')(props), tabTransitionProperty, tabTransitionDuration, tabTransitionEasing, borderRadius, borderRadius, backgroundColor, fontColorHover, backgroundColor, tabPadding ? tabPadding + "px" : spaceMixin('sm')(props), selectedTabIndicatorColor, indicatorBorderRadius, indicatorBorderRadius, selectedTabIndicatorHeight);
  })(props);
};
var fileTabCSS = function fileTabCSS(props) {
  return token({
    backgroundColor: 'Button.tertiary.backgroundColor',
    backgroundColorSelected: 'Button.tertiary.backgroundColor',
    borderColorSelected: 'Button.tertiary.borderColor',
    borderRadius: 'Button.borderRadius',
    borderWidth: 'Button.borderWidth',
    borderWidthSelected: 'Button.borderWidth',
    indicatorWidth: 'Tabs.selectedTabIndicatorHeight',
    selectedTabIndicatorColor: 'Tabs.selectedTabIndicatorColor',
    selectedTabIndicatorHeight: 'Tabs.selectedTabIndicatorHeight',
    tabPadding: 'Tabs.Tab.file.padding',
    tabTransitionDuration: 'Tabs.Tab.file.transition.duration',
    tabTransitionEasing: 'Tabs.Tab.file.transition.easing',
    tabTransitionProperty: 'Tabs.Tab.file.transition.property',
    tabGradientColorHover: 'Tabs.Tab.file.gradientColor.hover',
    tabGradientColorActive: 'Tabs.Tab.file.gradientColor.active'
  }, function (_ref2) {
    var backgroundColor = _ref2.backgroundColor,
      backgroundColorSelected = _ref2.backgroundColorSelected,
      borderColorSelected = _ref2.borderColorSelected,
      borderRadius = _ref2.borderRadius,
      borderWidth = _ref2.borderWidth,
      borderWidthSelected = _ref2.borderWidthSelected,
      indicatorWidth = _ref2.indicatorWidth,
      selectedTabIndicatorColor = _ref2.selectedTabIndicatorColor,
      selectedTabIndicatorHeight = _ref2.selectedTabIndicatorHeight,
      tabPadding = _ref2.tabPadding,
      tabTransitionDuration = _ref2.tabTransitionDuration,
      tabTransitionEasing = _ref2.tabTransitionEasing,
      tabTransitionProperty = _ref2.tabTransitionProperty,
      tabGradientColorHover = _ref2.tabGradientColorHover,
      tabGradientColorActive = _ref2.tabGradientColorActive;
    return css(["", "", "{border-radius:", "px ", "px 0 0;padding:", ";transition:", " ", "s ", ";&:hover:not(:disabled):before{background:linear-gradient( 90deg,", " 0%,", " 75%,", " );transition:background 0s;}&:active:not(:disabled):before{background:linear-gradient( 90deg,", " 0%,", " 75%,", " );}&[aria-selected='true']{background-color:", ";border-color:", ";border-width:", "px;border-bottom-color:", ";border-top-color:", ";border-top-width:", "px;padding-top:", "px;}}"], StyledTab, StyledTab, borderRadius, borderRadius, tabPadding ? tabPadding + "px" : spaceMixin('sm')(props), tabTransitionProperty, tabTransitionDuration, tabTransitionEasing, hexToAlpha(tabGradientColorHover, 0), hexToAlpha(tabGradientColorHover, 1), hexToAlpha(tabGradientColorHover, 1), hexToAlpha(tabGradientColorActive, 0), hexToAlpha(tabGradientColorActive, 1), hexToAlpha(tabGradientColorActive, 1), backgroundColorSelected, borderColorSelected, borderWidthSelected, backgroundColor, selectedTabIndicatorColor, selectedTabIndicatorHeight, tabPadding - indicatorWidth + borderWidth);
  })(props);
};
var fluidTabCSS = function fluidTabCSS(_ref3) {
  var fluid = _ref3.fluid;
  if (!fluid) {
    return "\n            " + StyledTab + " {\n                flex-grow: 0;\n                flex-basis: auto;\n            }\n        ";
  }
  return "\n        " + StyledTab + " {\n            flex-basis: 0; /* All tabs display equal width */\n            flex-grow: 1;\n            justify-content: center;\n\n            &:before {\n                display: none;\n            }\n        }\n    ";
};
var appearanceCSS = function appearanceCSS(props) {
  var appearance = props.appearance;
  switch (appearance) {
    case TABS_APPEARANCES.file:
      return fileTabCSS(props);
    default:
      return defaultTabCSS(props);
  }
};
var justifyContentCSS = function justifyContentCSS(_ref4) {
  var justifyContent = _ref4.justifyContent;
  return "\n    justify-content: " + justifyContent + ";\n";
};

/** @class TabListMixin */
/** @method */
export var TabListMixin = function TabListMixin(props) {
  return token('Button.borderWidth', function (borderWidth) {
    return css(["display:flex;margin-bottom:-", "px;", " ", " ", ""], borderWidth, appearanceCSS(props), inlineMediaQueryMixin('fluid', fluidTabCSS)(props), inlineMediaQueryMixin('justifyContent', justifyContentCSS)(props));
  })(props);
};